/* @flow */
/**
 * External dependencies
 */
import { size } from 'lodash';

/**
 * Internal dependencies
 */
import {
	ADD_ANSWER,
	INCREMENT_PROGRESS,
	USER_CONFIRM_SOUND,
	USER_SET_GENDER,
	USER_SET_PIN,
	USER_SET_TRACK,
} from '../constants/action-types';

/**
 * Flow
 */
import type {
	UserAddAnswerAction,
	UserConfigSoundAction,
	UserIncrementProgressAction,
	UserSetGenderAction,
	UserSetPinAction,
	UserSetTrackAction,
} from '../actions/user';

type UserReducerActions =
	UserAddAnswerAction |
	UserConfigSoundAction |
	UserIncrementProgressAction |
	UserSetGenderAction |
	UserSetTrackAction |
	UserSetPinAction;

export type UserState = {|
	answers: Object;
	gender: null | 'male' | 'female',
	pin: null | string;
	track: null | string;
	confirmedSound: boolean,
	progress: {
		init: string | number,
		track: number,
	};
|};

/**
 * Initial state
 */
export const initialState = {
	answers: {},
	gender: null,
	pin: null,
	track: null,
	confirmedSound: false,
	progress: {
		init: 0,
		track: 0,
	},
};

/**
 * Reducer
 */
export default function user( state: UserState = initialState, action: UserReducerActions ) : UserState {
	switch ( action.type ) {
		case USER_SET_PIN:
			return {
				...state,
				pin: action.payload,
			};

		case USER_SET_TRACK:
			return {
				...state,
				track: action.payload,
			};

		case USER_SET_GENDER:
			return {
				...state,
				gender: action.payload,
			};

		case USER_CONFIRM_SOUND:
			return {
				...state,
				confirmedSound: true,
			};

		case ADD_ANSWER:
			const number = size( state.answers ) + 1;
			const key = `block_${ number }`;

			return {
				...state,
				answers: {
					...state.answers,
					[ key ]: action.payload,
				},
			};

		case INCREMENT_PROGRESS:
			const progress = { ...state.progress };

			if ( state.track && progress.init !== 'done' ) {
				progress.init = 'done';
			} else if ( state.track ) {
				progress.track = progress.track + 1;
			} else {
				progress.init = progress.init + 1;
			}

			return {
				...state,
				progress,
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/user.js